import { Navigate, Outlet } from "react-router";
import { useAuth } from "@/lib/auth";

export function ProtectedRoute(): React.ReactElement {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
